// extracted by mini-css-extract-plugin
export default {"ForgotPassword":"ForgotPassword_ForgotPassword__RLlas","Form":"ForgotPassword_Form__njo2t","SuccessMessage":"ForgotPassword_SuccessMessage__Y5nBS"};